module.exports = __webpack_public_path__ + "img/tel1.4896e5fe.png";